import { Box, Button, TextField, Typography } from "@mui/material";
import React from "react";

export default function Comments() {
   return (
      <Box sx={{ mt: 2 }}>
         <div>
            <Typography variant="p14w700" gutterBottom>
               Comments
            </Typography> 
         </div>

         <div>
            <TextField className={'fullHeight'}
               size="large"
               sx={{
                  width: 1000,
               }}
               multiline
               maxRows={5}
               inputProps={{ style: { width: 400 } }}
            />
         </div>

         <div>
            <Button
               sx={{
                  width: 40,
                  bgcolor: "blue.main",
                  color: "white.main",
                  textTransform: "none",
                  fontWeight: "bold",
                  mt: 1,
                  "&:hover": {
                     bgcolor: "skyBlue.main",
                     color: "black.main",
                  },
               }}
            >
               View
            </Button>
         </div>
      </Box>
   );
}
